import styled from 'styled-components';
import { colors } from '../colorCodes';

export const Popover = styled.div`
    position: fixed;
    background: ${colors.whiteText};
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
    border-radius: 2px;
`;

export const OverlayPopup = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1500;
`;
